import React, { useState, useEffect } from 'react';
import { Grid, Paper, Button, TextField, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { createStyles, makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getBookingOverview, sendFileShare } from "../../actions/GenomicsResearchAction";
import { useHistory, useParams, useLocation } from "react-router-dom";
// import "./dashboard.css";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);

const GlassmorphismPaper = withStyles((theme) => ({
    root: {
        background: "rgba(255, 255, 255, 0.3)", // Semi-transparent background
        boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
        backdropFilter: "blur(4px)",
        borderRadius: "10px",
        padding: "20px",
    },
}))(Paper);

interface Props {
    getBookingOverview: any;
    bookingoverview: any;
    userDetails: any;
    sendFileShare: any;
    loading: any
}

const Dashboard: React.FC<Props> = ({
    getBookingOverview,
    bookingoverview,
    sendFileShare,
    loading,
}) => {
    const classes = useStyles();
    const { id } = useParams<{ id: string }>();
    const history = useHistory();
    const [docEmail, setDocEmail] = useState<any>([]);
    const [dataType, setDataType] = useState<any>();
    const [pass, setPass] = useState<any>();
    const handleSharedata = async (e: any) => {
        e.preventDefault();
        const clientData = {
            email: docEmail,
            file: dataType,
            project_id: id,
        };
        await sendFileShare(clientData);
    };
    const handleClick = () => {
        history.goBack();
    };

    return (
        <div style={{ width: "100%", margin: "60px auto" }}>
            <div style={{ backgroundColor: "#0b2857", border: "2px solid #0b2857", borderRadius: "10px" }}>
                <h2 style={{ textAlign: "center", color: "white" }}>Data To Share</h2>
            </div>
            <GlassmorphismPaper style={{ marginTop: "20px" }}>
                <form onSubmit={handleSharedata} style={{ width: "100%" }}>
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Data Type</InputLabel>
                                <Select
                                    label="Billing Completed"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    value={dataType || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setDataType(e.target.value)}
                                >
                                    <MenuItem value="none" disabled>Select Data Type</MenuItem>
                                    <MenuItem value="ftpFolder">Data Share</MenuItem>
                                    <MenuItem value="sampleQcReport">Sample QC</MenuItem>
                                    <MenuItem value="finalDataQcFile">Data Qc</MenuItem>
                                    <MenuItem value="finalAnalysisReport">Final Report</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label="Email ID"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Email ID"
                                fullWidth
                                value={docEmail}
                                required
                                onChange={(e) => setDocEmail(e.target.value.replace(/\s/g, ''))}
                            />
                        </Grid>
                        <Grid xs={12} sm={3} >
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                fullWidth
                                style={{ marginTop: "9px" }}
                            >
                                Send
                            </Button>
                        </Grid>
                        <Grid xs={12} sm={3} >
                            <Button
                                color="secondary"
                                variant="contained"
                                fullWidth
                                style={{ marginTop: "9px" }}
                                onClick={handleClick}
                            >
                                Back
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </GlassmorphismPaper>
        </div >
    );
};

const mapStateToProps = (state: any) => ({
    bookingoverview: state.GenomicsCAReducer.bookingoverview,
    loading: state.GenomicsCAReducer.loading,
});

export default connect(mapStateToProps, {
    getBookingOverview,
    sendFileShare,
})(Dashboard);
